export default "__VITE_ASSET__DAnJo0F$__"